export default function MediaPreviewModal({ media, onClose }) {
  const copyURL = () => {
    navigator.clipboard.writeText(media.url);
    alert("Media URL copied to clipboard!");
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl p-6 w-full max-w-lg relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-slate-600 hover:text-red-500"
        >
          ✕
        </button>

        {media.url.endsWith(".mp4") ? (
          <video
            src={media.url}
            controls
            className="rounded-lg w-full max-h-[60vh]"
          />
        ) : (
          <img
            src={media.url}
            alt={media.category}
            className="rounded-lg w-full max-h-[60vh] object-contain"
          />
        )}

        <div className="mt-4 flex justify-between items-center">
          <p className="text-sm text-slate-600">{media.category}</p>
          <button
            onClick={copyURL}
            className="bg-emerald-600 text-white px-4 py-1 rounded hover:bg-emerald-700 text-sm"
          >
            Copy URL
          </button>
        </div>
      </div>
    </div>
  );
}
